import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";


const AdaAlert = ({ message, type }) => {
  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <div className="login-alert-message-container">
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} variant="filled" severity={type} sx={{ width: "100%" }}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AdaAlert;
